import { Input } from '@bigcommerce/big-design';
import { useOrderProducts } from '../../../../context';
import { updateProducts } from '../../../../store/orderProducts';

export function EditQuantityColumn(product) {
	const [, dispatchOrderProducts] = useOrderProducts();

	return (
		<Input
			type="number"
			min={0}
			value={product.quantity ?? 1}
			onChange={(event) =>
				dispatchOrderProducts(
					updateProducts({
						...product,
						quantity: event.target.value,
					}),
				)
			}
		/>
	);
}
